const initialState = {
  home: null,
  isLoading: null,
  isError: null,
};

export default initialState;
